import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import * as Utility from '../../../shared/Utility'
import * as Constants from '../../../../config/Constants'
import { downloadErrorReportBulk } from '../CommunicationDownloadUtils'
import * as CommunicationRow from './CommunicationRow'
import { sendCommunicationAssistanceEmail } from '../../../../actions'
import getText from '../../../shared/i18n/labels'

// MODAL
import { Modal } from 'react-bootstrap'

// FORM
import EmailForm from './EmailForm'

// COMPONENTS
import { CommunicationStatus } from '../../../../config/CommunicationStatus'
import { PopupError } from '../../../shared/popups/PopupError'
import { PageSpinner } from '../../../shared/spinner/PageSpinner'

const defaultSize = (size = null) => ({
  registrationDate: Utility.getSize(size, { default: '10' }),
  communicationType: Utility.getSize(size, { default: '30' }),
  sendType: Utility.getSize(size, { default: '20' }),
  status: Utility.getSize(size, { default: '30' }),
  download: Utility.getSize(size, { default: '15' })
})

const getSize = () => {
  if (window.innerWidth <= Constants.BREAKPOINT_MD) return defaultSize('md')
  if (window.innerWidth <= Constants.BREAKPOINT_LG) return defaultSize('lg')
  return defaultSize()
}

export function CommunicationModal(props) {
  const lang = useSelector((state) => state.language.language)
  const labels = getText(lang)

  const [sizesClass, setSizesClass] = useState(getSize())

  const coraSubject = props.coraSubject
  const communications = props.communications || []
  const createdCommunications = communications.filter(
    (c) => c.communicationStatus === CommunicationStatus.CREATED
  )
  const createdWithError = communications.filter((c) => CommunicationRow.isCreatedWithError(c))
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    setSizesClass(getSize())
  }, [window.innerWidth])

  const sendEnabled = () => {
    return createdCommunications.length > 0 && Utility.isEmpty(props.delayedCommunicationDate)
  }

  const renderRows = (communications) => {
    return communications.map((communication, index) => {
      return (
        <CommunicationRow.CommunicationModalRow
          key={'communication-' + index}
          sizes={sizesClass}
          communication={communication}
          status={CommunicationRow.computeStatusText(communication)}
          isError={CommunicationRow.computeIsError(communication.communicationStatus)}
          downloadTxt={props.downloadTxt}
          downloadPecTz={props.downloadPecTz}
          downloadDgn={props.downloadDgn}
          downloadPdf={props.downloadPdf}
          downloadErrorReport={props.downloadErrorReport}
        />
      )
    })
  }

  const sendAssistanceRequest = (ids = []) => {
    setIsLoading(true)
    sendCommunicationAssistanceEmail(ids)
      .then(
        (res) => {
          Utility.notifySuccess(labels.ASSISTANCE_REQUEST_SENT)
        },
        (err) => PopupError({ text: labels.ASSISTANCE_REQUEST_ERROR })
      )
      .then(() => setIsLoading(false))
  }

  const renderDownloadEsitErrorsButton = () => {
    if (createdWithError.length > 0) {
      const ids = createdWithError.map((comm) => comm.id)
      return (
        <BulkErrorDownloadButton
          ids={ids}
          onAssistanceButtonClick={() => sendAssistanceRequest(ids)}
        />
      )
    } else {
      return <></>
    }
  }

  return (
    <Modal
      backdrop="static"
      show={props.showModal}
      onHide={props.closeModal}
      dialogClassName="modal-70w"
      aria-labelledby="contained-modal-title-vcenter"
      centered>
      <div className="bar"></div>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          <h2>{labels.SID_PROCESSING_RESULT}</h2>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {isLoading && <PageSpinner />}
        <div className="row communication">
          <div className="alert-header">
            <div className="star-table">
              <div className="text-start header-table bg-white">
                <div className={`${sizesClass.registrationDate} div-td`}>{labels.PERIOD}</div>
                <div className={`${sizesClass.communicationType} div-td`}>
                  {labels.COMMUNICATION_TYPE}
                </div>
                <div className={`${sizesClass.sendType} div-td`}>{labels.SEND_TYPE}</div>
                <div className={`${sizesClass.status} div-td`}>{labels.STATUS}</div>
                <div className={`${sizesClass.download} text-center div-td`}>{labels.DOWNLOAD}</div>
              </div>
              {renderRows(communications)}
            </div>
          </div>

          {sendEnabled() ? (
            <EmailForm
              closeModal={props.closeModal}
              emailAddress={coraSubject.coraSubjectSid?.email}
              flagPec={coraSubject.coraSubjectSid?.flagPec}
              sentCommunications={createdCommunications}
              subject={coraSubject}
              subjectId={coraSubject.id}>
              {renderDownloadEsitErrorsButton()}
            </EmailForm>
          ) : (
            <div>
              {Utility.isNotEmpty(props.delayedCommunicationDate) &&
                coraSubject.coraSubjectSid?.couldSendPec && (
                  <>
                    <div className="form-row mt-4 mb-2 justify-content-center align-item-center">
                      <span className="text-danger" style={{ fontSize: '1.5rem' }}>
                        <strong>
                          {labels.COMMUNICATIONS_WITH_NO_ERRORS_WILL_BE_SENT_VIA_PEC_ON_DATE}:
                          {Utility.formatDateForDisplay(props.delayedCommunicationDate)}
                        </strong>
                      </span>
                    </div>

                    <div className="form-row mt-4 mb-2 justify-content-center align-item-center">
                      <span style={{ fontSize: '1rem' }}>
                        <strong>
                          {labels.SENDER}: {coraSubject.coraSubjectSid?.pecEmail}
                        </strong>
                      </span>
                    </div>

                    <div className="form-row mt-4 mb-2 justify-content-center align-item-center">
                      <span style={{ fontSize: '1rem' }}>
                        <strong>
                          {labels.RECIPIENT}: {coraSubject.coraSubjectSid?.recipientEmail}
                        </strong>
                      </span>
                    </div>
                  </>
                )}
              <div className="form-row mt-2 form-relationship-button justify-content-between align-item-center">
                <div className="ms-auto me-auto">{renderDownloadEsitErrorsButton()}</div>
                <button className="btn btn-outline-primary" onClick={props.closeModal}>
                  {labels.CLOSE}
                </button>
              </div>
            </div>
          )}
        </div>
      </Modal.Body>
    </Modal>
  )
}

export function BulkErrorDownloadButton({ ids = [], onAssistanceButtonClick }) {
  const lang = useSelector((state) => state.language.language)
  const labels = getText(lang)

  return (
    <div className="d-flex align-items-center">
      <button className="btn btn-primary bg-yellow" onClick={() => downloadErrorReportBulk(ids)}>
        {labels.DOWNLOAD_ERRORS}
      </button>
      <button className="ms-3 btn btn-primary" onClick={onAssistanceButtonClick}>
        {labels.REQUEST_ASSISTANCE}
      </button>
    </div>
  )
}
